// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"paginationContainer--VRSGP","top":"top--cwFHb"};